import React, { useEffect, useMemo, useState } from 'react'
import { Button, Chip } from '@mui/material'
import { toast } from 'react-toastify'
import { getSync, marcarSync } from 'src/services/preciosService'
import TablaPrecios from './TablaPrecios'

const fmt = (n) => `$${Number(n || 0).toLocaleString('es-CO')}`

const chipEstado = (estado) => {
  const map = {
    ok: { color: 'success', txt: 'Reflejado' },
    pendiente: { color: 'warning', txt: 'Pendiente' },
    error: { color: 'error', txt: 'Requiere gestión' },
  }
  const s = map[estado] || map.pendiente
  return <Chip size="small" color={s.color} label={s.txt} variant="outlined" />
}

const VICTORY = ['Victory', 'Kymco', 'Kawasaki', 'Ceronte']

/**
 * Tab genérico de canal (IA Victory, IA TVS, Impulsa).
 * sistema: 'ia' | 'impulsa'   ·   grupo: 'victory' | 'tvs' | 'all'
 */
const CanalTab = ({ sistema, grupo, titulo, descripcion, onChanged }) => {
  const [rows, setRows] = useState([])
  const [isLoading, setIsLoading] = useState(false)

  const enGrupo = (marca) => {
    if (grupo === 'victory') return VICTORY.includes(marca)
    if (grupo === 'tvs') return !VICTORY.includes(marca)
    return true
  }

  const fetchData = async () => {
    setIsLoading(true)
    const sync = await getSync()
    if (sync && sync.success) setRows(sync.data.filter((r) => enGrupo(r.marca)))
    setIsLoading(false)
  }

  useEffect(() => {
    fetchData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const marcar = async (material) => {
    const res = await marcarSync({ material, sistema })
    if (res && res.success && res.id > 0) {
      toast.success('Actualización confirmada.')
      fetchData()
      onChanged?.()
    } else {
      toast.error('No se pudo confirmar.')
    }
  }

  const pendientes = rows.filter((r) => r[sistema] !== 'ok').length

  const columns = useMemo(
    () => [
      { accessorKey: 'marca', header: 'Marca' },
      { accessorKey: 'modelo', header: 'Modelo' },
      { accessorKey: 'pvp_actual', header: 'PVP vigente', Cell: ({ cell }) => fmt(cell.getValue()) },
      { accessorKey: 'bono', header: 'Bono vigente', Cell: ({ cell }) => (String(cell.getValue()) === '0' ? '—' : fmt(cell.getValue())) },
      { accessorKey: sistema, header: 'Estado', Cell: ({ cell }) => chipEstado(cell.getValue()) },
      {
        accessorKey: 'accion',
        header: 'Acción',
        enableColumnFilter: false,
        enableGlobalFilter: false,
        enableSorting: false,
        Cell: ({ row }) =>
          row.original[sistema] === 'ok' ? (
            <span style={{ color: '#9aa4ad', fontSize: 12 }}>—</span>
          ) : (
            <Button size="small" variant="contained" onClick={() => marcar(row.original.material)}>
              Marcar actualizado
            </Button>
          ),
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  )

  return (
    <div>
      <h3 className="precios-section-title" style={{ marginTop: 0, marginBottom: 2 }}>{titulo}</h3>
      <p style={{ fontSize: 12.5, color: '#6b7684', marginTop: 0 }}>{descripcion}</p>
      <p style={{ fontSize: 13 }}>
        <strong>{pendientes}</strong> referencia(s) por actualizar. Cuando reflejes el PVP/bono en tu sistema, presiona
        “Marcar actualizado”.
      </p>
      <TablaPrecios columns={columns} data={rows} isLoading={isLoading} pageSize={15} />
    </div>
  )
}

export default CanalTab
